var map = {
	"./journal0.png": "CVqi",
	"./journal1.png": "VsFy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "epfq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/journal.*\.png$
// module id = epfq
// module chunks = 3